import React, { useCallback, useEffect, useState } from "react";
import { fetchClientData } from "../../../redux/client/clientSlice";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "lodash";
import socket from "../../../context/socket";
import axios from "axios";
import Swal from "sweetalert2"; // Import Swal
import TabOne from "./Tab4Components/TabOne";
import TabTwo from "./Tab4Components/TabTwo";
import api from "../../../utils/api";

export const Tab4 = ({ setSelectedCards, selectedCards, setSelectedTab, selectedTab, setPrsuggections, isPrsuggections,
  selectedMember, setSelectedMember }) => {
  const roomId = new URLSearchParams(window.location.search).get("clientId");

  const [isEiPortfolio, setIsEiPortfolio] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  // console.log("isEiKeyActionPoints",isEiKeyActionPoints);

const [loadingFolio, setLoadingFolio] = useState(false);
  const fetchGetEiFolioData = async () => {
    setLoadingFolio(true);
    try {
      // Show loading modal before API call
      Swal.fire({
        text: "Loading...",
        imageUrl: 'https://www.finedge.in/assets/images/download.gif',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
      // API Call
      const response = await api.post(`advisor/getEiFolio`, { clientid: roomId });

      console.log("response", response);
      // Set Portfolio Data
      setIsEiPortfolio(response?.data)

    } catch (error) {
      console.error("Error fetching getEiFolio data:", error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Failed to load getEiFolio data. Please try again later.',
      });
    } finally {
      Swal.close(); // Ensure the alert closes in both success and error cases
      setLoadingFolio(false);
    }
  };


  useEffect(() => {
    fetchGetEiFolioData();
  }, [selectedTab]);



  return (
    <div>
      <div className="row">
        <div className="col">
          {/* {selectedTab === 1 && (
            <TabOne
              roomId={roomId}
              isEiKeyActionPoints={isEiKeyActionPoints}
              setSelectedTab={setSelectedTab}
              selectedTab={selectedTab}
            />
          )}  */}
          {selectedTab === 1 && (
            <TabTwo
              loadingFolio={loadingFolio}
              roomId={roomId}
              isEiPortfolio={isEiPortfolio}
              setSelectedTab={setSelectedTab}
              selectedTab={selectedTab}
              fetchGetEiFolioData={fetchGetEiFolioData}   //send fun for recall fun when  modal update
              setIsChecked={setIsChecked}
              isChecked={isChecked}
            />
          )}


        </div>
      </div>
    </div>
  );
};
